var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"19.5","stroke":"#EEEEEE","strokeOpacity":"0.5","key":0}),React.createElement("path",{"d":"M13.923 15.8525C14.9851 15.8525 15.846 14.9901 15.846 13.9262C15.846 12.8624 14.9851 12 13.923 12C12.861 12 12 12.8624 12 13.9262C12 14.9901 12.861 15.8525 13.923 15.8525Z","fill":"#EEEEEE","key":1}),React.createElement("path",{"d":"M17.6616 17.3124V27.9991H20.9742V22.7143C20.9742 21.3198 21.2361 19.9694 22.9622 19.9694C24.6646 19.9694 24.6857 21.5637 24.6857 22.8024V28H28V22.1394C28 19.2607 27.3813 17.0483 24.0221 17.0483C22.4094 17.0483 21.3284 17.9348 20.8863 18.7738H20.8414V17.3124H17.6616ZM12.2635 17.3124H15.5813V27.9991H12.2635V17.3124Z","fill":"#EEEEEE","key":2})]);
}

LinkedinIcon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
